import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-side-banner',
  templateUrl: './side-banner.component.html',
  styleUrls: ['./side-banner.component.scss']
})
export class SideBannerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
